import { useState, useEffect } from 'react';
import { ethers } from 'ethers';

const useChainId = () => {
    const [chainId, setChainId] = useState(null);

    useEffect(() => {
        // Check if the Ethereum provider is injected by the browser (like MetaMask)
        if (typeof window.ethereum !== 'undefined') {
            const provider = new ethers.BrowserProvider(window.ethereum);

            const getChainId = async () => {
                const { chainId } = await provider.getNetwork();
                setChainId(chainId);
            };

            // Get the initial chain ID
            getChainId();

            // Listen for network changes
            window.ethereum.on('chainChanged', (networkChainId) => {
                setChainId(parseInt(networkChainId, 16));
            });

            // Cleanup the event listener on unmount
            return () => {
                window.ethereum.removeListener('chainChanged', () => {});
            };
        } else {
            console.warn(
                'No Ethereum provider found. Install MetaMask or use a compatible browser.'
            );
        }
    }, []);

    return chainId;
};

export default useChainId;
